/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalSubmissionListEntryLeadFacility
 */
export interface PalSubmissionListEntryLeadFacility {
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadFacility
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadFacility
     */
    name: string;
}

/**
 * Check if a given object implements the PalSubmissionListEntryLeadFacility interface.
 */
export function instanceOfPalSubmissionListEntryLeadFacility(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function PalSubmissionListEntryLeadFacilityFromJSON(json: any): PalSubmissionListEntryLeadFacility {
    return PalSubmissionListEntryLeadFacilityFromJSONTyped(json, false);
}

export function PalSubmissionListEntryLeadFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionListEntryLeadFacility {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function PalSubmissionListEntryLeadFacilityToJSON(value?: PalSubmissionListEntryLeadFacility | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

